<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import I18nUtils from "@/utils/i18nUtils";

export default {
  name: "App",
  data() {
    return {
      show: true,
    };
  },
  created() {
    // console.log(111,process.env.LANG?process.env.LANG:'zh')
    // let oLang = process.env.LANG?process.env.LANG:'zh';
    // this.$i18n.locale = oLang;
    // console.log(JSON.stringify(this.$route.query));
    // console.log("mode", process.env.NODE_ENV);
    // console.log("root", process.env.CHANNEL_PLAT);
    // 初始化渠道
    I18nUtils.initLanguage(this);
  },
};
</script>

<style lang="scss">
#app {
  font-family: "Microsoft YaHei", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue